import * as React from 'react';
/**
 *
 * Original name: highlight
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A335
 *
 */
export const HighlightPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m53.644 15.851-3.515-3.515a8 8 0 0 0-11.313 0L14.185 36.967l.827 2.482a5.967 5.967 0 0 1-1.449 6.14l-5.792 5.792L18.013 54.8l2.378-2.378a5.969 5.969 0 0 1 6.14-1.449l2.482.827 24.632-24.636a8.01 8.01 0 0 0-.001-11.313ZM27.933 47.219l-.138-.046a9.932 9.932 0 0 0-7.386.442l-2.044-2.044a9.928 9.928 0 0 0 .441-7.387l-.046-.137 1.712-1.712 9.172 9.172-1.711 1.712Zm4.54-4.54L23.3 33.507l14.673-14.672 9.172 9.172-14.672 14.672Zm18.343-18.343-.844.844-9.172-9.173.843-.843a4.1 4.1 0 0 1 5.657 0l3.515 3.515a4 4 0 0 1 .001 5.657Z", fill: "currentColor" })));
